<!--
/*******************************************************************************
*@ 컴포넌트명   : PushStupYesPopup.vue
*@ 컴포넌트설명 : PushYes안내팝업
*@ 사용전문     : 
********************************************************************************
** 날짜/시      작성자   변경내역
********************************************************************************
** 
********************************************************************************/
-->
<template>
  <article>
    <!-- 앱 PUSH 안내 -->
    <modal-pop
      :opened.sync="isYesPopupOpen"
      :modalHeader="true"
      :modalFooter="true"
      :btnClose="true"
      :titleCenter="true"
      title="MPSH-01-01-00-09"
    >
      <template #content>
        <strong class="info-question mtop-12">
          <!-- 2021.12.21 이 기기로<br />PUSH 알림을 받는 것에 동의 하셨습니다. -->
          {{$getGlobalDateFmt(today)}} {{$t("MPSH-01-01-02-01")}}
        </strong>
      </template>
      <template #footer>
        <!-- 2022-02-04 수정 -->
        <button class="btn bottom negative" @click="() => {isYesPopupOpen = false}">
          <!-- 닫기 -->
          {{$t("MPSH-01-01-00-03")}}
        </button>
        <button
          class="btn bottom positive"
          @click="() =>{ $router.push({ name: 'noticeService' }) }"
        >
          <!-- 알림 서비스 -->
          {{$t("MPSH-01-01-00-07")}}
        </button>
      </template>
    </modal-pop>
  </article>
</template>

<script>
export default {
  props: ["opened"],
  mounted() {},
  created() {},
  data() {
    return {
      today: this.$getDateToString(),
    };
  },
  computed: {
    isYesPopupOpen: {
      get() {
        return this.opened;
      },
      set(value) {
        this.$emit("update:opened", value);
      },
    },
  },
  methods: {
    setAcnoAll() {},
  },
};
</script>
